"use strict";
/**
 * Pair Builder Page Handler
 * Wires navigation and placeholder interactions for the arbitrage monitor UI.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPairBuilderPage = setupPairBuilderPage;
const navigation_service_1 = require("../services/navigation-service");
const state_1 = require("../state");
const monitor_state_service_1 = require("../services/monitor-state-service");
const api_1 = require("../api");
const monitor_ui_1 = require("../ui/monitor-ui");
const pair_builder_data_service_1 = require("../services/pair-builder-data-service");
const const_1 = require("../const");
const polymarket_us_1 = require("../api/polymarket-us");
const monitor_state_service_2 = require("../services/monitor-state-service");
function setupPairBuilderPage() {
    const backBtn = document.getElementById("pair-builder-back-btn");
    const statusBtn = document.getElementById("pair-builder-status-btn");
    const addBtn = document.getElementById("pair-builder-add-btn");
    const feedback = document.getElementById("pair-builder-feedback");
    const kalshiCategorySelect = document.getElementById("pair-builder-kalshi-category");
    const pmSportSelect = document.getElementById("pair-builder-pm-sport");
    const searchInput = document.getElementById("pair-builder-search");
    const kalshiToggle = document.getElementById("pair-builder-kalshi-toggle");
    const pmToggle = document.getElementById("pair-builder-pm-toggle");
    const kalshiPanel = document.getElementById("pair-builder-kalshi-panel");
    const pmPanel = document.getElementById("pair-builder-pm-panel");
    const orderModeToggle = document.getElementById("pair-builder-order-mode-toggle");
    const orderModeLabel = document.getElementById("pair-builder-order-mode-label");
    if (backBtn) {
        backBtn.addEventListener("click", () => (0, navigation_service_1.navigateToEvents)());
    }
    if (statusBtn) {
        statusBtn.addEventListener("click", () => (0, navigation_service_1.navigateToMonitorStatus)());
    }
    if (searchInput) {
        searchInput.addEventListener("input", (event) => {
            const value = event.target.value;
            (0, monitor_state_service_1.setPairBuilderSearch)(value);
        });
    }
    const setupRollup = (button, panel) => {
        if (!button || !panel)
            return;
        const card = panel.closest(".pair-builder-panel");
        const applyState = (collapsed) => {
            if (collapsed) {
                card?.classList.add("collapsed");
                button.textContent = "Expand";
                button.setAttribute("aria-expanded", "false");
            }
            else {
                card?.classList.remove("collapsed");
                button.textContent = "Collapse";
                button.setAttribute("aria-expanded", "true");
            }
        };
        applyState(false);
        button.addEventListener("click", () => {
            const collapsed = card?.classList.contains("collapsed") ?? false;
            applyState(!collapsed);
        });
    };
    setupRollup(kalshiToggle, kalshiPanel);
    setupRollup(pmToggle, pmPanel);
    const render = () => {
        const state = (0, state_1.getState)();
        if (kalshiCategorySelect) {
            kalshiCategorySelect.value = state.pairBuilder.kalshiCategory;
        }
        if (pmSportSelect) {
            pmSportSelect.value = state.pairBuilder.pmSport;
        }
        if (searchInput) {
            searchInput.value = state.pairBuilder.search;
        }
        const isReal = state.monitorStatus.orderMode === "real";
        if (orderModeToggle) {
            orderModeToggle.checked = isReal;
        }
        if (orderModeLabel) {
            orderModeLabel.textContent = isReal ? "Real" : "Mock";
            orderModeLabel.classList.toggle("order-mode-real", isReal);
        }
        (0, monitor_ui_1.renderPairBuilder)({
            ...(0, monitor_ui_1.getPairBuilderRenderState)(state),
            onSelectKalshi: (ticker) => {
                (0, monitor_state_service_1.setPairBuilderSelection)({ selectedKalshiTicker: ticker });
            },
            onSelectPm: (slug) => {
                (0, monitor_state_service_1.setPairBuilderSelection)({ selectedPmSlug: slug });
            },
        });
    };
    if (addBtn) {
        addBtn.addEventListener("click", async () => {
            const state = (0, state_1.getState)();
            const kalshiTicker = state.pairBuilder.selectedKalshiTicker;
            const pmSlug = state.pairBuilder.selectedPmSlug;
            if (!kalshiTicker || !pmSlug)
                return;
            if (feedback) {
                feedback.textContent = "Adding pair...";
            }
            try {
                await (0, api_1.addMonitorPair)({ kalshiTicker, pmSlug });
                const pairs = await (0, api_1.getMonitorPairs)();
                (0, monitor_state_service_1.setMonitorStatus)({
                    pairs: pairs.pairs,
                    pairCount: pairs.count,
                    lastUpdated: Date.now(),
                });
                (0, monitor_state_service_1.setPairBuilderSelection)({
                    selectedKalshiTicker: null,
                    selectedPmSlug: null,
                });
                if (feedback) {
                    feedback.textContent = "Pair added.";
                }
            }
            catch (error) {
                console.error("Failed to add monitor pair:", error);
                if (feedback) {
                    feedback.textContent = "Failed to add pair.";
                }
            }
        });
    }
    render();
    (0, state_1.subscribe)(() => render());
    if (orderModeToggle) {
        orderModeToggle.addEventListener("change", async () => {
            const newMode = orderModeToggle.checked ? "real" : "mock";
            try {
                await (0, api_1.setMonitorOrderMode)(newMode);
                (0, monitor_state_service_1.setMonitorStatus)({ orderMode: newMode });
            }
            catch (error) {
                console.error("Failed to set order mode:", error);
                // Revert checkbox to previous state
                orderModeToggle.checked = !orderModeToggle.checked;
            }
        });
    }
    // Fetch initial monitor status to sync order mode
    (0, api_1.getMonitorStatus)()
        .then((res) => {
        (0, monitor_state_service_1.setMonitorStatus)({ orderMode: res.status.orderMode ?? "mock" });
    })
        .catch((err) => console.error("Failed to fetch initial order mode:", err));
    const kalshiOptions = Object.entries(const_1.LEAGUES).map(([label, value]) => ({
        label,
        value,
    }));
    if (kalshiCategorySelect) {
        kalshiCategorySelect.innerHTML = kalshiOptions
            .map((option) => `<option value="${option.value}">${option.label}</option>`)
            .join("");
        kalshiCategorySelect.value = (0, state_1.getState)().pairBuilder.kalshiCategory;
        kalshiCategorySelect.addEventListener("change", () => {
            (0, monitor_state_service_1.updatePairBuilderState)({
                selectedKalshiTicker: null,
                kalshiMarkets: [],
                kalshiLoading: true,
                kalshiCategory: kalshiCategorySelect.value,
            });
            void (0, pair_builder_data_service_1.loadPairBuilderKalshiMarkets)(kalshiCategorySelect.value);
        });
    }
    if (pmSportSelect) {
        pmSportSelect.innerHTML = `<option value="">All</option><option disabled>Loading...</option>`;
        (0, polymarket_us_1.listPolymarketUsSports)()
            .then((response) => {
            const payload = response.data ?? [];
            const sports = Array.isArray(payload)
                ? payload
                : Array.isArray(payload.sports)
                    ? payload.sports
                    : [];
            const sportNames = sports
                .map((sport) => {
                const typed = sport;
                return typed.slug ?? typed.sport ?? typed.name;
            })
                .filter((name) => Boolean(name));
            const uniqueSports = Array.from(new Set(sportNames)).sort();
            (0, monitor_state_service_2.setPairBuilderMarkets)({ pmSports: uniqueSports });
            pmSportSelect.innerHTML = ["", ...uniqueSports]
                .map((value) => `<option value="${value}">${value || "All"}</option>`)
                .join("");
            pmSportSelect.value = (0, state_1.getState)().pairBuilder.pmSport;
        })
            .catch((error) => {
            console.error("Failed to load PM-US sports:", error);
            pmSportSelect.innerHTML = `<option value="">All</option>`;
        });
        pmSportSelect.addEventListener("change", () => {
            (0, monitor_state_service_1.updatePairBuilderState)({
                selectedPmSlug: null,
                pmSport: pmSportSelect.value,
            });
            void (0, pair_builder_data_service_1.loadPairBuilderPolymarketMarkets)();
        });
    }
    void (0, pair_builder_data_service_1.loadPairBuilderKalshiMarkets)((0, state_1.getState)().pairBuilder.kalshiCategory);
    void (0, pair_builder_data_service_1.loadPairBuilderPolymarketMarkets)();
}
